import { $t } from '@/utils/languageAuto';
import { __decorate, __extends } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import Breadcrumb from '@/components/breadcrumb/index.vue';
import addOrEdit from './components/addOrEdit.vue';

var ReturnOrderEditPage = function (_super) {
  __extends(ReturnOrderEditPage, _super);

  function ReturnOrderEditPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.breadcrumbData = [];
    _this.code = '';
    return _this;
  }

  ReturnOrderEditPage.prototype.created = function () {
    this.code = this.$route.query.code;
    this.breadcrumbData = [{
      routerName: 'ReturnOrderPage',
      title: this.t('退货列表'),
      query: {
        order_type: this.$enum.order.ReturnOrderType.ReturnOrder
      }
    }, {
      title: this.t('编辑退货')
    }];
  };

  ReturnOrderEditPage = __decorate([Component({
    components: {
      Breadcrumb: Breadcrumb,
      addOrEdit: addOrEdit
    }
  })], ReturnOrderEditPage);
  return ReturnOrderEditPage;
}(Vue);

export default ReturnOrderEditPage;